import {
  isPaymentLinkNotGenerated,
  paymentStatus
} from '@features/transactions/helpers/installmentSchedule';
import { PaymentOrderTermType } from '@types';

import InstallmentTermRow from './InstallmentTermRow';

type InstallmentScheduleBlockProps = {
  rows: PaymentOrderTermType[];
  memberId?: string;
  isDefaultCurrency: boolean;
  source: 'member-details' | 'transaction-history';
};

const InstallmentScheduleBlock = ({
  rows,
  memberId,
  isDefaultCurrency,
  source
}: InstallmentScheduleBlockProps) => {
  if (!rows.length) return null;

  const amountSymbolClass = isDefaultCurrency ? '' : '!text-sm !font-medium';
  let paymentLinkTermFound = false;
  return (
    <div className="mt-4">
      {source === 'member-details' && (
        <div className="text-md mb-3 font-medium text-cofeeNeutral10">
          Installment schedule
        </div>
      )}
      <div className="flex flex-col">
        {rows.map((row, index) => {
          const paymentLinkNotGenerated =
            isPaymentLinkNotGenerated(row) ||
            (!paymentLinkTermFound && Number(row.amount ?? 0) === 0);

          if (
            row.can_send_payment_link ||
            paymentStatus(row) === 'processing'
          ) {
            paymentLinkTermFound = true;
          }

          return (
            <InstallmentTermRow
              key={`${row.term_id ?? ''}-${row.due_date}`}
              row={row}
              index={index}
              rows={rows}
              memberId={memberId ?? ''}
              amountSymbolClass={amountSymbolClass}
              isDefaultCurrency={isDefaultCurrency}
              paymentLinkNotGenerated={paymentLinkNotGenerated}
            />
          );
        })}
      </div>
    </div>
  );
};

export default InstallmentScheduleBlock;
